const obj = {
    // 类目树
    getSonCategoryEdit: '/goods/category/getSonCategoryEdit/', //列表 一级
    treeEdit: "/goods/category/treeEdit/", //获取一级下的所有子目录
    treeFormal: "/goods/category/treeFormal/", //获取目录树  查看
    getAttrGroupList: "/goods/attrGroup/getAttrGroupList",
    /**获取品牌列表*/
    deleteEdits: "/goods/category/deleteEdit/",
    /*删除类目*/
    freeMove: "/goods/category/freeMove",
    /*类目拖拽*/
    addEdits: "/goods/category/addEdit",
    /**添加类目*/
    updateEdits: "/goods/category/updateEdit",
    /*类目编辑*/
    siblingMove: "/goods/category/siblingMove",
    /*上下移动*/
    syncCategoryData: "/goods/category/syncCategoryData/",
    /*叶子类目的同步*/
    syncCategoryTree: "/goods/category/syncCategoryTree",
    /*目录树的同步*/





    // 属性分组
    addAttrGroupEdit: "/goods/attrGroup/addAttrGroupEdit",
    /*新增属性分组*/
    editAttrGroupEdit: "/goods/attrGroup/editAttrGroupEdit",
    /**编辑属性分组*/
    cancelAttrGroupEdit: "/goods/attrGroup/cancelAttrGroupEdit/",
    /*删除属性分组*/
    editAttrGroupSortNo: "/goods/attrGroup/editAttrGroupSortNo",
    /*排序*/
    giveUpAttrGroupEdit: "/goods/attrGroup/giveUpAttrGroupEdit/",
    /*放弃删除*/
    findAttrGroupEdit: "/goods/attrGroup/findAttrGroupEdit/",
    /*编辑属性分组时的回显*/
    getAttrGroups: "/goods/attrGroup/getAttrGroups",
    /*属性分组*/






    // 品牌
    getCategoryBrandList: "/goods/categoryBrand/getCategoryBrandList",
    /*品牌列表*/
    queryCategoryBrand: "/goods/categoryBrand/queryCategoryBrand",
    getBrand: "/goods/categoryBrand/getBrand/",
    /*获取品牌列表  弹窗中左侧*/
    getCategoryBrand: "/goods/categoryBrand/getCategoryBrand/",
    /*获取品牌列表  弹窗中右侧*/
    addCategoryBrand: "/goods/categoryBrand/addCategoryBrand",
    /*绑定品牌*/
    editCategoryNameSortNo: "/goods/categoryBrand/editCategoryNameSortNo",
    /*品牌排序*/




    // 属性
    /*属性列表*/
    listEdit: "/goods/attrItem/listEdit",
    listFormal: "/goods/attrItem/listFormal",
    /*添加属性*/
    addEdit: '/goods/attrItem/addEdit',
    /*删除属性*/
    deleteEdit: '/goods/attrItem/deleteEdit/', //{attrId}
    /*属性分组列表*/
    queryAttrGroups: '/goods/attrGroup/queryAttrGroups/', //{categoryId}
    /*放弃删除*/
    abortDel: '/goods/attrItem/abortDel/', //{attrId}
    /*属性回显*/
    detailEdit: 'goods/attrItem/detailEdit/',
    /*属性更新*/
    updateEdit: '/goods/attrItem/updateEdit',
    /*属性排序*/
    updateEditSort:'/goods/attrItem/updateEditSort',


    //基本信息
    editProfile: "/goods/category/editProfile/",
    formalProfile: "/goods/category/formalProfile/",
}
export default obj;